import React from 'react'

class Variant extends React.Component {
  constructor(props) {
    super(props)
    this.keybase = Math.random() * 10000

    this.state = {}
  }

  render() {
    const { price, label, options, labelTitle } = this.props.variant
    let variantLabel = false
    let variantPrice = false
    let variantOptions = false

    if (price) {
      variantPrice = <span className="v-price">${price}</span>
    }

    if (options && options.length) {
      variantOptions = options.map(option => (
        <span
          key={`option_${this.keybase}_${option.name}`}
          className="variant-option"
        >
          {option.name && (
            <span>
              <b>{option.name}</b>:
            </span>
          )}{' '}
          {option.value}
        </span>
      ))
    }

    if (label) {
      variantLabel = (
        <span className="variant-option">
          {labelTitle ? (
            <span>
              <b>{labelTitle}</b>:{' '}
            </span>
          ) : (
            false
          )}
          {label}
        </span>
      )
    }

    return (
      <div className="variant">
        {variantLabel}
        {variantOptions}
        {variantPrice}
      </div>
    )
  }
}

Variant.defaultProps = {
  variant: { price: false, label: false }
}

module.exports = Variant



// WEBPACK FOOTER //
// ./src/views/Components/Variant.js